import { render, staticRenderFns } from "./UiProgressBars.vue?vue&type=template&id=ca3a25ba"
import script from "./UiProgressBars.vue?vue&type=script&lang=js"
export * from "./UiProgressBars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports